import { Typography, message, Button, Row, Col, Space, Card, Input } from "antd";
import PageWrapper from "../../utils/PageWrapper";
import PageTitle from "../../utils/PageTitle";
import { Plus, Users } from "lucide-react";
import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../layout/auth";
import UsuariosIndex from "./UsuariosIndex";
import UsuarioEditForm from "./UsuarioEditForm";

export default function Usuarios() {
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [record, setRecord] = useState({});
  const [search, setSearch] = useState("");

  const auth = useAuth();

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/usuarios/getUsuarios`)
      .then((res) => {
        setUsers(res.data);
      })
      .catch((err) => {
        message.error(err.message);
      });
  }, []);

  useEffect(() => {
    if (search) {
      const filtered = users.filter((user) => {
        return (
          user?.Nombre?.toString().toLowerCase().includes(search.toLowerCase()) ||
          user?.Email?.toString().toLowerCase().includes(search.toLowerCase())
        );
      });
      setFilteredUsers(filtered);
    } else {
      setFilteredUsers(users);
    }
  }, [search, users]);

  return (
    <PageWrapper className="usuarios-main-card">
      <PageTitle icon={<Users />} title="Usuarios" />
      <div
        style={{
          padding: "16px",
          background: "rgba(249, 250, 251, 0.8)",
          borderRadius: "12px",
          border: "1px solid rgba(229, 231, 235, 0.6)",
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.05)",
          marginBottom: "24px",
        }}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <Input.Search
              placeholder="Buscar usuario"
              onSearch={(value) => {
                setSearch(value);
              }}
              enterButton="Buscar"
              size="large"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12} style={{ textAlign: "right" }}>
            <Space>
              <Button
                type="primary"
                icon={<Plus size={18} strokeWidth={1.5} />} 
                size="large"
                onClick={() => {
                  setIsModalVisible(true);
                  setIsEdit(false);
                }}
                style={{
                  borderRadius: "8px",
                  height: "40px",
                }}
              >
                Agregar
              </Button>
            </Space>
          </Col>
        </Row>
      </div>
      <UsuariosIndex
        inspectors={search ? filteredUsers : users}
        setInspectors={setUsers}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        record={record}
        setRecord={setRecord}
      />
      <UsuarioEditForm
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
        isEdit={isEdit}
        setIsEdit={setIsEdit}
        record={record}
        setRecord={setRecord}
        setInspectors={setUsers}
      />
    </PageWrapper>
  );
}